export default "__VITE_ASSET__addadf72__"